import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface AppStore {
  /** Epoch time after which to show the match auto banner */
  autoBannerDismissedUntil: number;
  /** Set the epoch time after which to show the matcha auto banner */
  setAutoBannerDismissedUntil: (date: number) => void;
  chainDeprecationDismissedUntilByWallet: Partial<Record<string, number>>;
  setChainDeprecationDismissedUntil: (walletAddress: string, date: number) => void;
}

export const useAppStore = createWithEqualityFn<AppStore>()(
  persist(
    (set) => ({
      autoBannerDismissedUntil: new Date().getTime(),
      setAutoBannerDismissedUntil: (autoBannerDismissedUntil: number) =>
        set({ autoBannerDismissedUntil }),
      chainDeprecationDismissedUntilByWallet: {},
      setChainDeprecationDismissedUntil: (walletAddress, date) =>
        set((state) => ({
          chainDeprecationDismissedUntilByWallet: {
            ...state.chainDeprecationDismissedUntilByWallet,
            [walletAddress.toLowerCase()]: date,
          },
        })),
    }),
    {
      name: 'app-store',
      partialize: (state) => ({
        autoBannerDismissedUntil: state.autoBannerDismissedUntil,
        chainDeprecationDismissedUntilByWallet: state.chainDeprecationDismissedUntilByWallet,
      }),
    },
  ),
  shallow,
);

export const autoBannerSelectors = ({
  autoBannerDismissedUntil,
  setAutoBannerDismissedUntil,
}: AppStore) => ({
  autoBannerDismissedUntil,
  setAutoBannerDismissedUntil,
});

export const chainDeprecationSelectors = ({
  chainDeprecationDismissedUntilByWallet,
  setChainDeprecationDismissedUntil,
}: AppStore) => ({
  chainDeprecationDismissedUntilByWallet,
  setChainDeprecationDismissedUntil,
});
